import { useEffect } from 'react';

import { ClaimPromoGiftDialogController } from '../components/Dialogs/PromoDialogs/ClaimPromoGiftDialog/ClaimPromoGiftDialogController';
import DailyLimitDialog from '../components/Dialogs/PromoDialogs/DailyLimitDialog/DailyLimitDialog';
import { InvalidPromoDialogController } from '../components/Dialogs/PromoDialogs/InvalidPromoDialog/InvalidPromoDialogController';
import { useFlag } from '../services/launchDarkly';
import { useStores } from '../stores/useStores';

export function useSetPromoPopup() {
  const { portalStore, promotionStore, featureManagerStore } = useStores();
  const isRedesignEnabled = useFlag('ui_redesign_promo_link', false);

  useEffect(() => {
    if (promotionStore.isPromoListenersEmpty) {
      promotionStore.addPromoListener((promotion) =>
        portalStore.openPortal(ClaimPromoGiftDialogController, {
          promotion,
          persistent: isRedesignEnabled,
          beforeClose: () => {
            promotionStore.markPromotionFlowFinished();
            featureManagerStore.onDialogFinished('PromoGift');
          },
        }),
      );
    }

    if (promotionStore.isPromoErrorListenersEmpty) {
      promotionStore.addPromoErrorListener((errorCode) => {
        const DialogComponent =
          errorCode === 'PromoCodeDailyLimitError' ? DailyLimitDialog : InvalidPromoDialogController;

        portalStore.openPortal(DialogComponent, {
          errorCode,
          persistent: isRedesignEnabled,
          beforeClose: () => {
            promotionStore.markPromotionFlowFinished();
            featureManagerStore.onDialogFinished('PromoGift');
          },
        });
      });
    }
  }, [portalStore, promotionStore, featureManagerStore, isRedesignEnabled]);
}
